import { types, } from 'mobx-state-tree';
export const ChimeMediaPlacementType = types.model('ChimeMediaPlacement', {
    AudioHostUrl: types.maybeNull(types.string),
    AudioFallbackUrl: types.maybeNull(types.string),
    ConcatenatedVideoArn: types.maybeNull(types.string),
    ScreenDataUrl: types.maybeNull(types.string),
    ScreenSharingUrl: types.maybeNull(types.string),
    ScreenViewingUrl: types.maybeNull(types.string),
    SignalingUrl: types.maybeNull(types.string),
    TurnControlUrl: types.maybeNull(types.string),
});
export const ChimeAttendeeType = types.model('ChimeAttendee', {
    AttendeeId: types.maybeNull(types.string),
    ExternalUserId: types.maybeNull(types.string),
    JoinToken: types.maybeNull(types.string),
});
export const ChimeMeetingType = types.model('ChimeMeeting', {
    ExternalMeetingId: types.maybeNull(types.string),
    MediaRegion: types.maybeNull(types.string),
    MediaPlacement: types.maybeNull(ChimeMediaPlacementType),
});
//# sourceMappingURL=ChimeTypes.js.map